import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { SkillSpecializationApiService } from './services/skill-specialization-api.service';
import { SkillProgressApiService } from './services/skill-progress-api.service';
import { SkillChatApiService } from './services/skill-chat-api.service';
import { SkillTestApiService } from './services/skill-test-api.service';
import { SkillPracticeApiService } from './services/skill-practice-api.service';
import { SkillSettingsApiService } from './services/skill-settings-api.service';
import { SkillRoleService } from './services/skill-role.service';
import { SkillRequestApiService } from './services/skill-request-api.service';
import { SkillGroupApiService } from './services/skill-group-api.service';
import { SkillAiStatisticsApiService } from './services/skill-ai-statistics-api.service';
import { SkillSpecializationFacadeService } from './services/skill-specialization-facade.service';
import { LearningFacadeService } from './services/learning-facade.service';
import { SkillAiStatisticsFacadeService } from './services/skill-ai-statistics-facade.service';
import { SkillRoleGuard } from './guards/skill-role.guard';
import { SkillLearningHttpInterceptor } from './interceptors/skill-learning-http.interceptor';

import { SkillSpecializationListComponent } from './components/admin/specialization-list/specialization-list.component';
import { SkillSpecializationListContainerComponent } from './components/admin/specialization-list-container/specialization-list-container.component';
import { SkillSpecializationFormComponent } from './components/admin/specialization-form/specialization-form.component';
import { CreateSpecializationContainerComponent } from './components/admin/create-specialization-container/create-specialization-container.component';
import { EditSpecializationContainerComponent } from './components/admin/edit-specialization-container/edit-specialization-container.component';
import { SkillTheoryLevelEditorComponent } from './components/admin/theory-level-editor/theory-level-editor.component';
import { SkillPracticeLevelEditorComponent } from './components/admin/practice-level-editor/practice-level-editor.component';
import { DocumentUploaderComponent } from './components/admin/document-uploader/document-uploader.component';
import { EditSpecializationGeneralPageComponent } from './components/admin/edit-specialization-general-page/edit-specialization-general-page.component';
import { EditSpecializationLevelsPageComponent } from './components/admin/edit-specialization-levels-page/edit-specialization-levels-page.component';
import { AiStatisticsContainerComponent } from './components/admin/ai-statistics-container/ai-statistics-container.component';
import { AiStatisticsSummaryComponent } from './components/admin/ai-statistics-summary/ai-statistics-summary.component';
import { AiStatisticsTimeseriesComponent } from './components/admin/ai-statistics-timeseries/ai-statistics-timeseries.component';
import { AiBudgetStatusComponent } from './components/admin/ai-budget-status/ai-budget-status.component';

import { LearningTreeComponent } from './components/user/learning-tree/learning-tree.component';
import { LearningTreeContainerComponent } from './components/user/learning-tree/learning-tree-container.component';
import { TopicChecklistComponent } from './components/user/topic-checklist/topic-checklist.component';
import { AiChatComponent } from './components/user/ai-chat/ai-chat.component';
import { TestContainerComponent } from './components/user/test/test-container.component';
import { PracticeLevelComponent } from './components/user/practice-level/practice-level.component';
import { PracticeRequirementsComponent } from './components/user/practice-level/practice-requirements.component';
import { PracticeTaskStatusComponent } from './components/user/practice-level/practice-task-status.component';
import { PracticeLevelContainerComponent } from './components/user/practice-level/practice-level-container.component';
import { LearningSessionContainerComponent } from './components/user/learning-session/learning-session-container.component';
import { SkillDocumentCardComponent } from './components/shared/skill-document-card/skill-document-card.component';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgbModule,
    TranslateModule,
  ],
  declarations: [
    SkillSpecializationListComponent,
    SkillSpecializationListContainerComponent,
    SkillSpecializationFormComponent,
    CreateSpecializationContainerComponent,
    EditSpecializationContainerComponent,
    EditSpecializationGeneralPageComponent,
    EditSpecializationLevelsPageComponent,
    AiStatisticsContainerComponent,
    AiStatisticsSummaryComponent,
    AiStatisticsTimeseriesComponent,
    AiBudgetStatusComponent,
    SkillTheoryLevelEditorComponent,
    SkillPracticeLevelEditorComponent,
    DocumentUploaderComponent,
    LearningTreeComponent,
    LearningTreeContainerComponent,
    TopicChecklistComponent,
    AiChatComponent,
    TestContainerComponent,
    PracticeLevelComponent,
    PracticeRequirementsComponent,
    PracticeTaskStatusComponent,
    PracticeLevelContainerComponent,
    LearningSessionContainerComponent,
    SkillDocumentCardComponent,
  ],
  exports: [
    SkillSpecializationListContainerComponent,
    CreateSpecializationContainerComponent,
    EditSpecializationContainerComponent,
    AiStatisticsContainerComponent,
    LearningTreeContainerComponent,
    LearningSessionContainerComponent,
  ],
  providers: [
    SkillSpecializationApiService,
    SkillProgressApiService,
    SkillChatApiService,
    SkillTestApiService,
    SkillPracticeApiService,
    SkillSettingsApiService,
    SkillRoleService,
    SkillRequestApiService,
    SkillGroupApiService,
    SkillAiStatisticsApiService,
    SkillSpecializationFacadeService,
    LearningFacadeService,
    SkillAiStatisticsFacadeService,
    SkillRoleGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SkillLearningHttpInterceptor,
      multi: true,
    },
  ],
})
export class SkillLearningModule {}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/skill-learning.module.ts